(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotec-bend"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('spotec-activity-loop')) {
  customElements.define('spotec-activity-loop', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bend-track');
      this.originals = [...this.track.children];
      if (!this.originals.length) return;
      this.abort = new AbortController();
      const on = (el, type, fn, options = {}) => el.addEventListener(type, fn, { ...options, signal: this.abort.signal });
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.track.style.scrollBehavior = 'auto';
      this.track.style.overflowAnchor = 'none';
      this.track.style.direction = 'ltr';
      this.hovered = false;
      this.focused = false;
      this.touching = false;
      this.dragging = false;
      this.resumeAt = 0;
      this.lastTime = 0;
      this.position = 0;
      this.cycle = 0;
      this.clones = [];
      this.build();
      this.lazyPosters();
      on(this.track, 'scroll', () => { this.normalize(); this.paint(); }, { passive: true });
      on(this.track, 'pointerenter', (e) => { if (e.pointerType === 'mouse') this.hovered = true; });
      on(this.track, 'pointerleave', (e) => { if (e.pointerType === 'mouse') this.hovered = false; });
      on(this.track, 'focusin', (e) => { this.focused = !!(e.target.matches && e.target.matches(':focus-visible')); });
      on(this.track, 'focusout', (e) => { if (!this.track.contains(e.relatedTarget)) this.focused = false; });
      on(this.track, 'touchstart', () => { this.touching = true; }, { passive: true });
      const endTouch = () => { this.touching = false; this.resumeAt = performance.now() + 1500; };
      on(window, 'touchend', endTouch, { passive: true });
      on(window, 'touchcancel', endTouch, { passive: true });
      on(this.track, 'wheel', () => { this.resumeAt = performance.now() + 1500; }, { passive: true });
      on(this.track, 'pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        this.dragging = true; this.moved = false; this.lastX = e.clientX; this.startX = e.clientX;
        this.track.classList.add('is-dragging');
      });
      on(window, 'pointermove', e => {
        if (!this.dragging) return;
        if (Math.abs(e.clientX - this.startX) > 5) this.moved = true;
        this.track.scrollLeft += (this.lastX - e.clientX) * 1.2;
        this.lastX = e.clientX;
        this.normalize(); this.paint();
      });
      const endDrag = () => { this.dragging = false; this.track.classList.remove('is-dragging'); this.resumeAt = performance.now() + 1200; };
      on(window, 'pointerup', endDrag);
      on(window, 'pointercancel', endDrag);
      on(window, 'blur', () => { endDrag(); endTouch(); });
      on(this.track, 'dragstart', e => e.preventDefault());
      on(this.track, 'click', e => { if (this.moved && e.detail !== 0) { e.preventDefault(); this.moved = false; } });
      on(this.motion, 'change', () => this.paint());
      on(document, 'shopify:block:select', e => {
        const panel = this.originals.find(p => p === e.target || p.contains(e.target));
        if (panel) { this.resumeAt = performance.now() + 60000; this.track.scrollLeft = panel.offsetLeft - this.track.offsetLeft; this.normalize(); this.paint(); }
      });
      this.resize = new ResizeObserver(() => {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => { if (this.isConnected) this.build(); });
      });
      this.resize.observe(this.track);
      this.originals.forEach(p => this.resize.observe(p));
      const tick = time => {
        if (!this.isConnected) return;
        // Off screen: stop the loop (saves battery); the observer below starts it again
        if (!this.visible) { this.frame = 0; this.lastTime = 0; return; }
        const dt = this.lastTime ? Math.min(time - this.lastTime, 50) : 0;
        this.lastTime = time;
        if (this.dataset.autoscroll === 'true' && !this.motion.matches && !document.hidden && !this.hovered && !this.focused && !this.touching && !this.dragging && time >= this.resumeAt && this.cycle) {
          // Accumulate fractional pixels even in browsers that round scrollLeft.
          this.position += Number(this.dataset.autoscrollSpeed || .6) * dt / (1000 / 60);
          this.position = this.origin + ((this.position - this.origin) % this.cycle + this.cycle) % this.cycle;
          this.track.scrollLeft = this.position;
          this.paint();
        } else this.position = this.track.scrollLeft;
        this.frame = requestAnimationFrame(tick);
      };
      this.visible = true;
      this.viewObserver = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        if (this.visible && !this.frame) this.frame = requestAnimationFrame(tick);
      }, { rootMargin: '200px 0px' });
      this.viewObserver.observe(this);
      this.frame = requestAnimationFrame(tick);
    }
    build() {
      this.flatPainted = false;
      const phase = this.cycle ? ((this.track.scrollLeft - this.origin) % this.cycle + this.cycle) % this.cycle / this.cycle : 0;
      this.clones.forEach(p => { p.querySelectorAll('video').forEach(v => v.pause()); p.remove(); });
      this.clones = [];
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.cycle = this.originals.reduce((sum, p) => sum + p.offsetWidth + gap, 0);
      if (!this.cycle || !this.track.clientWidth) return;
      const repeats = Math.ceil(this.track.clientWidth / this.cycle) + 1;
      const copy = () => {
        const fragment = document.createDocumentFragment();
        this.originals.forEach(original => {
          const clone = original.cloneNode(true);
          clone.removeAttribute('data-shopify-editor-block');
          clone.setAttribute('aria-hidden', 'true');
          [clone, ...clone.querySelectorAll('[id]')].forEach(el => el.removeAttribute('id'));
          clone.querySelectorAll('a, button, input, video').forEach(el => el.setAttribute('tabindex', '-1'));
          clone.querySelectorAll('video').forEach((video, i) => {
            const source = original.querySelectorAll('video')[i];
            const sync = () => { try { video.currentTime = source.currentTime; } catch (_) {} };
            video.addEventListener('loadedmetadata', sync, { once: true });
            video.muted = true;
          });
          this.clones.push(clone); fragment.append(clone);
        });
        return fragment;
      };
      for (let i = 0; i < repeats; i++) this.track.prepend(copy());
      for (let i = 0; i < repeats; i++) this.track.append(copy());
      this.origin = repeats * this.cycle;
      this.position = this.origin + phase * this.cycle;
      this.track.scrollLeft = this.position;
      this.paint();
      this.lazyPosters();
      this.lazyVideos();
    }
    lazyPosters() {
      const apply = () => this.querySelectorAll('video[data-poster]').forEach((video) => {
        if (!video.getAttribute('poster')) video.setAttribute('poster', video.dataset.poster);
      });
      if (this.postersReady || !('IntersectionObserver' in window)) { this.postersReady = true; apply(); return; }
      if (this.posterObserver) return;
      this.posterObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.postersReady = true;
        apply();
        this.posterObserver.disconnect();
      }, { rootMargin: '800px 0px' });
      this.posterObserver.observe(this);
    }
    lazyVideos() {
      if (this.dataset.autoplayVideos !== 'true' || !('IntersectionObserver' in window)) return;
      // Hemat data (9 Okt rev. B): Data Saver / 2G / 3G -> video tidak diputar, poster tetap tampil.
      const net = navigator.connection || {};
      if (net.saveData || /(^|-)2g|3g/.test(net.effectiveType || '')) return;
      if (!this.videoObserver) {
        this.videoObserver = new IntersectionObserver((entries) => {
          entries.forEach(({ target: video, isIntersecting }) => {
            if (isIntersecting) {
              video.muted = true;
              if (video.preload !== 'auto') video.preload = 'auto';
              const played = video.play();
              if (played && played.catch) played.catch(() => {});
            } else {
              video.pause();
            }
          });
        }, { rootMargin: '200px 0px' });
      }
      this.videoObserver.disconnect();
      this.track.querySelectorAll('video').forEach((video) => this.videoObserver.observe(video));
    }
    normalize() {
      if (!this.cycle) return;
      const current = this.track.scrollLeft;
      const target = this.origin + ((current - this.origin) % this.cycle + this.cycle) % this.cycle;
      // Identical panels occupy the new coordinates, so there is no visible reset.
      if (Math.abs(target - current) > 1) {
        this.track.scrollLeft = target;
        this.position += target - current;
      }
    }
    paint() {
      const flat = this.motion.matches || matchMedia('(max-width: 749px)').matches;
      // Phones / reduced motion: panels are flat, so only write the styles once
      if (flat && this.flatPainted) return;
      const width = this.track.clientWidth;
      if (!width) return;
      this.flatPainted = flat;
      const center = this.track.scrollLeft + width / 2;
      [...this.track.children].forEach(panel => {
        const offset = Math.max(-1, Math.min(1, (panel.offsetLeft - this.track.offsetLeft + panel.offsetWidth / 2 - center) / (width / 2)));
        const angle = offset * Number(this.dataset.maxAngle || 14) * -1;
        panel.style.transform = flat ? 'none' : `rotateY(${angle.toFixed(2)}deg) translateZ(${-Math.abs(offset) * 50}px) scale(${1 - Math.abs(offset) * .05})`;
      });
    }
    disconnectedCallback() {
      this.abort?.abort(); this.resize?.disconnect(); this.viewObserver?.disconnect(); this.videoObserver?.disconnect(); this.posterObserver?.disconnect(); this.posterObserver = null;
      cancelAnimationFrame(this.frame); cancelAnimationFrame(this.resizeFrame);
      this.querySelectorAll('video').forEach(v => v.pause());
      this.clones?.forEach(p => p.remove());
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotec-category"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('spotec-category-page')) customElements.define('spotec-category-page',class extends HTMLElement {
 connectedCallback(){
 this.abort=new AbortController();const on=(el,type,fn)=>el.addEventListener(type,fn,{signal:this.abort.signal});
 const list=this.querySelector('ul.spotec-category__grid'), items=[...this.querySelectorAll('[data-item]')], size=this.querySelector('[data-size-filter]'), sort=this.querySelector('[data-sort]');
 const sizeList=item=>item.dataset.sizes.split(',').map(x=>x.trim()).filter(Boolean);
 [...new Set(items.flatMap(sizeList))].sort((a,b)=>a.localeCompare(b,undefined,{numeric:true})).forEach(value=>{const option=document.createElement('option');option.value=value;option.textContent=value;size.append(option);});
 const amount=item=>Number(item.dataset.price.replace(/[^0-9]/g,''))||0;
 const render=()=>{let ordered=[...items];if(sort.value==='price-asc')ordered.sort((a,b)=>amount(a)-amount(b));if(sort.value==='price-desc')ordered.sort((a,b)=>amount(b)-amount(a));if(sort.value==='name')ordered.sort((a,b)=>a.dataset.name.localeCompare(b.dataset.name));let count=0;ordered.forEach(item=>{item.hidden=!!size.value&&!sizeList(item).includes(size.value);if(!item.hidden)count++;list.append(item);});const countEl=this.querySelector('[data-count]');countEl.textContent=(countEl.dataset.countLabel||'{n} PRODUCTS').replace('__N__',count).replace('{n}',count);this.querySelector('[data-empty]').hidden=count>0;};
 on(size,'change',render);on(sort,'change',render);this.querySelectorAll('[data-columns]').forEach(b=>on(b,'click',()=>{this.dataset.columns=b.dataset.columns;this.querySelectorAll('button[data-columns]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));}));render();
 }
 disconnectedCallback(){this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotec-chat"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('spotec-ai-chat')) {
  customElements.define('spotec-ai-chat', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const on = (el, event, fn) => el.addEventListener(event, fn, { signal: this.abort.signal });
      this.dialog = this.querySelector('dialog');
      this.launcher = this.querySelector('[data-open]');
      on(this.launcher, 'click', () => this.open());
      on(this.querySelector('[data-close]'), 'click', () => this.dialog.close());
      on(this.dialog, 'close', () => {
        this.unlock();
        this.launcher.setAttribute('aria-expanded', 'false');
        this.launcher.focus({ preventScroll: true });
      });
      on(this.dialog, 'click', e => {
        const r = this.dialog.getBoundingClientRect();
        if (e.target === this.dialog && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)) this.dialog.close();
      });
      on(document, 'shopify:section:deselect', e => { if (e.target.contains(this) && this.dialog.open) this.dialog.close(); });
    }
    open() {
      if (!this.frame) {
        let url;
        try { url = new URL(this.dataset.url); } catch (_) { return; }
        if (url.protocol !== 'https:') return;
        this.frame = document.createElement('iframe');
        this.frame.className = 'spotec-chat__frame';
        this.frame.title = 'Chat SPOTEC AI';
        this.frame.referrerPolicy = 'strict-origin-when-cross-origin';
        this.frame.src = url.href;
        this.querySelector('[data-body]').append(this.frame);
      }
      if (this.dialog.open) return;
      this.dialog.showModal();
      this.launcher.setAttribute('aria-expanded', 'true');
      this.oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.locked = true;
      this.querySelector('[data-close]').focus();
    }
    unlock() {
      if (!this.locked) return;
      document.body.style.overflow = this.oldOverflow;
      this.locked = false;
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.dialog?.open) this.dialog.close();
      this.unlock();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotec-duo-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('spotec-duo-banner')) {
  customElements.define('spotec-duo-banner', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.timers = new Set();
      const on = (el, type, fn, options = {}) => el.addEventListener(type, fn, { ...options, signal: this.abort.signal });
      this.querySelectorAll('[data-panel]').forEach(panel => {
        let start = null;
        let moved = false;
        let releaseTimer;
        const release = () => {
          start = null;
          clearTimeout(releaseTimer);
          this.timers.delete(releaseTimer);
          releaseTimer = setTimeout(() => { panel.classList.remove('is-touching'); this.timers.delete(releaseTimer); }, 220);
          this.timers.add(releaseTimer);
        };
        on(panel, 'pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          clearTimeout(releaseTimer);
          this.timers.delete(releaseTimer);
          start = { x: event.clientX, y: event.clientY };
          moved = false;
          panel.classList.add('is-touching');
        });
        on(window, 'pointermove', event => {
          if (start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > 8) moved = true;
        }, { passive: true });
        on(window, 'pointerup', () => { if (start) release(); }, { passive: true });
        on(window, 'pointercancel', () => { if (start) { moved = true; release(); } }, { passive: true });
        on(window, 'blur', () => { if (start) release(); });
        on(panel, 'dragstart', event => event.preventDefault());
        on(panel, 'click', event => { if (moved && event.detail !== 0) { event.preventDefault(); moved = false; } });
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.timers?.forEach(clearTimeout);
      this.querySelectorAll('[data-panel]').forEach(panel => panel.classList.remove('is-touching'));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotec-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('spotec-store-header')) {
  customElements.define('spotec-store-header', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const on = (el, event, handler) => el.addEventListener(event, handler, { signal: this.abort.signal });
      const runningPause = this.querySelector('[data-running-pause]');
      if (runningPause) on(runningPause, 'click', () => {
        const paused = runningPause.closest('.spotec-h3__announcement').classList.toggle('is-paused');
        runningPause.setAttribute('aria-pressed', String(paused));
        runningPause.setAttribute('aria-label', paused ? 'Play running text' : 'Pause running text');
        runningPause.textContent = paused ? '▶' : 'Ⅱ';
      });
      this.search = this.querySelector('[data-search-dialog]');
      this.promo = this.querySelector('[data-promo-dialog]');
      this.mobile = this.querySelector('.spotec-h3__mobile');
      this.dialogs = [...this.querySelectorAll('dialog')];
      this.locked = false;
      this.opener = null;
      on(this, 'click', event => {
        const searchLink = event.target.closest('[data-open-search]');
        if (searchLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
          event.preventDefault();
          this.openDialog(this.search, searchLink);
        }
        const close = event.target.closest('[data-close-dialog]');
        if (close) close.closest('dialog').close();
      });
      this.dialogs.forEach(dialog => {
        on(dialog, 'keydown', event => {
          if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); dialog.close(); }
        });
        on(dialog, 'click', event => {
          const r = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) dialog.close();
        });
        on(dialog, 'close', () => {
          this.unlock();
          this.querySelector('[data-open-search]').setAttribute('aria-expanded', 'false');
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        });
      });
      on(this.search.querySelector('form'), 'submit', event => {
        const input = this.search.querySelector('input[name="q"]');
        input.value = input.value.trim();
        if (!input.value) { event.preventDefault(); input.focus(); }
      });
      on(this, 'keydown', event => {
        if (event.key === 'Escape' && this.mobile.open && !this.dialogs.some(d => d.open)) {
          this.mobile.open = false;
          this.mobile.querySelector('summary').focus();
        }
      });
      on(document, 'click', event => { if (!this.contains(event.target)) { this.mobile.open = false; this.querySelectorAll('.spotec-h3__category[open]').forEach(d => d.open = false); } });
      this.querySelectorAll('.spotec-h3__category').forEach(category => {
        on(category, 'toggle', () => {
          if (category.open) category.parentElement.querySelectorAll('.spotec-h3__category').forEach(other => { if (other !== category) other.open = false; });
        });
        on(category, 'keydown', event => { if (event.key === 'Escape') { event.stopPropagation(); category.open = false; category.querySelector('summary').focus(); } });
      });
      // Switch to a mobile menu if merchant labels no longer fit the row.
      this.updateHeader = () => {
        const announcement = this.querySelector('.spotec-h3__announcement');
        const top = announcement ? Math.max(0, announcement.getBoundingClientRect().bottom) : 0;
        this.style.setProperty('--sh-top', `${top}px`);
        this.style.setProperty('--sh-height', `${this.querySelector('.spotec-h3__row').offsetHeight}px`);
        this.classList.toggle('is-scrolled', window.scrollY > 8 || this.mobile.open);
      };
      this.classList.add('is-enhanced');
      on(window, 'scroll', this.updateHeader);
      on(this.mobile, 'toggle', this.updateHeader);
      this.resize = new ResizeObserver(() => { this.fitNavigation(); this.updateHeader(); });
      this.resize.observe(this.querySelector('.spotec-h3__row'));
      const announcement = this.querySelector('.spotec-h3__announcement');
      if (announcement) this.resize.observe(announcement);
      this.updateHeader();
      document.fonts?.ready.then(() => { if (this.isConnected) this.fitNavigation(); });
      this.fitNavigation();
      if (this.promo && (!window.Shopify?.designMode || this.dataset.promoPreview === 'true')) {
        this.promoKey = `spotec-promo:${this.dataset.sectionId}:${this.dataset.campaign}`;
        let seen = false;
        try { seen = sessionStorage.getItem(this.promoKey) === 'shown'; } catch (_) { /* Storage can be unavailable. */ }
        if (!seen || window.Shopify?.designMode) {
          this.promoTimer = setTimeout(() => {
            if (!this.isConnected || document.hidden || document.querySelector('dialog[open]') || this.mobile.open || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName)) return;
            this.openDialog(this.promo, document.activeElement);
            try { sessionStorage.setItem(this.promoKey, 'shown'); } catch (_) {}
          }, Number(this.dataset.promoDelay) * 1000);
        }
      }
    }
    fitNavigation() {
      if (window.innerWidth <= 990) { this.classList.remove('is-compact'); return; }
      this.classList.remove('is-compact');
      const nav = this.querySelector('.spotec-h3__nav');
      const row = this.querySelector('.spotec-h3__row');
      const overflow = nav.scrollWidth > nav.clientWidth + 1 || row.scrollWidth > row.clientWidth + 1;
      this.classList.toggle('is-compact', overflow);
      if (!overflow) this.mobile.open = false;
    }
    openDialog(dialog, opener) {
      this.dialogs.filter(d => d.open).forEach(d => d.close());
      this.mobile.open = false;
      this.opener = opener;
      dialog.showModal();
      this.oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.locked = true;
      if (dialog === this.search) {
        this.querySelector('[data-open-search]').setAttribute('aria-expanded', 'true');
        dialog.querySelector('input').focus();
      }
    }
    unlock() {
      if (!this.locked) return;
      document.body.style.overflow = this.oldOverflow;
      this.locked = false;
    }
    disconnectedCallback() {
      clearTimeout(this.promoTimer);
      this.abort?.abort();
      this.resize?.disconnect();
      this.dialogs?.filter(d => d.open).forEach(d => d.close());
      this.unlock();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotec-hero-slider"] && !Shopify.designMode) return;
  try {
    
/* Native custom element: each section owns its listeners, media and timer. */
if (!customElements.get('spotec-hero-slider')) {
  customElements.define('spotec-hero-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (!this.slides.length) return;
      this.abort = new AbortController();
      const on = (target, event, handler) => target.addEventListener(event, handler, { signal: this.abort.signal });
      this.index = 0;
      this.hovered = false;
      this.focused = false;
      this.editorSelected = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.paused = this.motion.matches;
      this.dots = [...this.querySelectorAll('[data-go]')];
      this.pauseButton = this.querySelector('[data-pause]');
      this.querySelector('[data-controls]').hidden = this.slides.length < 2;
      on(this, 'click', (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-go')) this.show(Number(button.dataset.go), true);
        if (button.hasAttribute('data-step')) this.show(this.index + Number(button.dataset.step), true);
        if (button.hasAttribute('data-pause')) { this.paused = !this.paused; this.update(); }
      });
      on(this, 'keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
      });
      on(this, 'pointerenter', (event) => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } });
      on(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      on(this, 'focusin', () => { this.focused = true; this.schedule(); });
      on(this, 'focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.schedule(); });
      on(this, 'touchstart', (event) => { this.touch = { x: event.touches[0].clientX, y: event.touches[0].clientY }; });
      on(this, 'touchend', (event) => {
        if (!this.touch) return;
        const dx = event.changedTouches[0].clientX - this.touch.x;
        const dy = event.changedTouches[0].clientY - this.touch.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1), true);
        this.touch = null;
      });
      on(document, 'visibilitychange', () => this.update());
      on(this.motion, 'change', () => { if (this.motion.matches) this.paused = true; this.update(); });
      on(this.mobile, 'change', () => this.update());
      on(document, 'shopify:block:select', (event) => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.editorSelected = true; this.show(index); }
      });
      on(document, 'shopify:block:deselect', () => { this.editorSelected = false; this.update(); });
      this.show(0);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.querySelectorAll('video').forEach(video => video.pause());
    }

    show(index, announce = false) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== this.index;
        slide.inert = i !== this.index;
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      this.style.setProperty('--control-color', this.slides[this.index].dataset.controlsColor);
      if (announce) this.querySelector('[data-status]').textContent = `Banner ${this.index + 1} of ${this.slides.length}`;
      this.update();
    }

    update() {
      this.pauseButton.textContent = this.paused ? '▶' : 'Ⅱ';
      this.pauseButton.setAttribute('aria-label', this.paused ? 'Play banners and videos' : 'Pause banners and videos');
      this.slides.forEach((slide, i) => {
        const host = slide.querySelector('[data-video-host]');
        if (!host) return;
        const play = i === this.index && !this.motion.matches && !this.paused && !document.hidden && !this.editorSelected;
        if (play && !host.firstElementChild) host.append(slide.querySelector('template').content.cloneNode(true));
        const video = host.querySelector('video');
        host.classList.remove('is-playing');
        if (!video) return;
        if (play) {
          video.muted = true;
          video.play().then(() => { if (!slide.hidden && !video.paused) host.classList.add('is-playing'); }).catch(() => {});
        } else video.pause();
      });
      this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.paused || this.hovered || this.focused || this.editorSelected || document.hidden) return;
      this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) * 1000);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotec-news"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('spotec-news')) {
  customElements.define('spotec-news', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const on = (el, type, fn, opts = {}) => el.addEventListener(type, fn, { ...opts, signal: this.abort.signal });
      const track = this.querySelector('[data-track]');
      const controls = this.querySelector('[data-controls]');
      const buttons = [...this.querySelectorAll('[data-step]')];
      const refresh = () => {
        const max = track.scrollWidth - track.clientWidth;
        if (controls) controls.hidden = max < 2;
        buttons.forEach(b => b.disabled = Number(b.dataset.step) < 0 ? track.scrollLeft <= 1 : track.scrollLeft >= max - 1);
      };
      buttons.forEach(b => on(b, 'click', () => {
        const item = track.firstElementChild;
        if (!item) return;
        const distance = item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        track.scrollBy({ left: Number(b.dataset.step) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }));
      let down = false, moved = false, startX = 0, startScroll = 0;
      on(track, 'pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
      });
      on(window, 'pointermove', e => {
        if (!down) return;
        if (Math.abs(e.clientX - startX) > 5) {
          moved = true; track.classList.add('is-dragging');
          track.scrollLeft = startScroll + startX - e.clientX;
        }
      });
      const release = () => { down = false; track.classList.remove('is-dragging'); };
      on(window, 'pointerup', release); on(window, 'pointercancel', release); on(window, 'blur', release);
      on(track, 'dragstart', e => e.preventDefault());
      on(track, 'click', e => { if (moved && e.detail !== 0) { e.preventDefault(); moved = false; } });
      on(track, 'scroll', refresh, { passive: true });
      this.resize = new ResizeObserver(refresh); this.resize.observe(track);
      refresh();
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotec-pdp-story"] && !Shopify.designMode) return;
  try {
    
// Headings occupy their own rows. Both columns share the remaining content rows.
function spxStoryRowPlan(groupCounts, detailCount) {
  let nextRow = 1;
  const headings = [];
  const groups = [];
  const contentRows = [];
  for (const count of groupCounts) {
    headings.push(nextRow++);
    const rows = [];
    for (let i = 0; i < count; i++) {
      rows.push(nextRow);
      contentRows.push(nextRow++);
    }
    groups.push(rows);
  }
  const details = [];
  for (let i = 0; i < detailCount; i++) {
    details.push(contentRows[i] ?? nextRow++);
  }
  return { headings, groups, details };
}

if (!customElements.get('spx-story-grid')) {
  customElements.define('spx-story-grid', class extends HTMLElement {
    connectedCallback() {
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.alignRows());
      };
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      this.schedule();
    }
    alignRows() {
      // Reset placement when a weight-only column becomes hidden or reappears.
      this.querySelectorAll('[data-story-cell]').forEach(node => {
        node.style.removeProperty('grid-row');
        node.style.removeProperty('grid-column');
        node.removeAttribute('data-story-cell');
      });
      const columns = Array.from(this.children).filter(node => node.classList.contains('spx-story__col') && !node.hidden);
      this.removeAttribute('data-aligned');
      if (columns.length !== 2) return;
      const groups = Array.from(columns[0].querySelectorAll('.spx-story__group')).map(group => ({
        heading: group.querySelector('.spx-story__h'),
        rows: Array.from(group.querySelectorAll('.spx-story__list > li')).filter(row => !row.closest('[hidden]'))
      }));
      const rightHeading = columns[1].querySelector('.spx-story__h');
      const rightRows = Array.from(columns[1].querySelectorAll('.spx-story__list > li')).filter(row => !row.closest('[hidden]'));
      const plan = spxStoryRowPlan(groups.map(group => group.rows.length), rightRows.length);
      const place = (node, column, row) => {
        if (!node) return;
        node.dataset.storyCell = '';
        node.style.gridColumn = String(column);
        node.style.gridRow = String(row);
      };
      groups.forEach((group, index) => {
        place(group.heading, 1, plan.headings[index]);
        group.rows.forEach((row, i) => place(row, 1, plan.groups[index][i]));
      });
      place(rightHeading, 2, 1);
      rightRows.forEach((row, i) => place(row, 2, plan.details[i]));
      this.setAttribute('data-aligned', '');
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
    }
  });
}

  if (!customElements.get('spx-story-weight')) {
    customElements.define('spx-story-weight', class extends HTMLElement {
      connectedCallback() {
        this.start = () => {
          this.syncVisibility();
          if (this.unsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            const variantId = String(data?.variant?.id || '');
            // Ignore events from recommendations or another product.
            const info = document.querySelector('product-info[data-section="' + CSS.escape(String(data?.sectionId || '')) + '"]');
            if (info && info.dataset.productId !== this.dataset.productId) return;
            if (!info && !this.querySelector('[data-weight-variant="' + CSS.escape(variantId) + '"]')) return;
            this.querySelectorAll('[data-weight-variant]').forEach(row => {
              row.hidden = row.dataset.weightVariant !== variantId;
            });
            this.syncVisibility();
          });
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, { once: true });
        else this.start();
      }
      syncVisibility() {
        if (this.hasAttribute('data-weight-only')) {
          this.closest('.spx-story__col').hidden = !this.querySelector('[data-weight-variant]:not([hidden])');
        }
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.start);
        this.unsubscribe?.();
        this.unsubscribe = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotec-product-detail"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('spotec-product-detail')) customElements.define('spotec-product-detail', class extends HTMLElement {
 connectedCallback() {
  this.abort=new AbortController(); const on=(el,event,fn)=>el.addEventListener(event,fn,{signal:this.abort.signal});
  const gallery=this.querySelector('[data-gallery]'); const photos=()=>[...gallery.querySelectorAll('[data-photo]:not([hidden])')];
  const count=this.querySelector('[data-photo-count]'); const controls=this.querySelector('[data-gallery-controls]');
  const refresh=()=>{ const list=photos(); const index=Math.min(list.length-1,Math.max(0,Math.round(gallery.scrollLeft/(gallery.clientWidth||1)))); count.textContent=`${index+1} / ${list.length}`; controls.hidden=list.length<2; };
  on(gallery,'scroll',refresh); this.resize=new ResizeObserver(refresh); this.resize.observe(gallery); refresh();
  this.querySelectorAll('[data-gallery-step]').forEach(b=>on(b,'click',()=>gallery.scrollBy({left:Number(b.dataset.galleryStep)*gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));
  this.querySelectorAll('[data-color-button]').forEach(button=>on(button,'click',()=>{
   this.querySelectorAll('[data-color-button]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
   this.querySelector('[data-color-name]').textContent=button.dataset.label;
   gallery.querySelectorAll('[data-color]').forEach(p=>p.hidden=!!p.dataset.color && p.dataset.color!==button.dataset.color);
   if(button.dataset.src){let img=this.querySelector('[data-primary] img'); if(!img){img=document.createElement('img');this.querySelector('[data-primary]').append(img);} img.removeAttribute('srcset');img.src=button.dataset.src;img.alt=this.dataset.name+' — '+button.dataset.label;}
   gallery.scrollLeft=0;refresh();
  }));
  const dialog=this.querySelector('dialog');
  on(this.querySelector('[data-guide]'),'click',()=>dialog.showModal()); on(this.querySelector('[data-guide-close]'),'click',()=>dialog.close());
  on(this.querySelector('[data-add]'),'click',()=>{const size=this.querySelector('input[type="radio"]:checked');this.querySelector('[data-notice]').textContent=size?`Selected: size ${size.value}, quantity ${this.querySelector('[data-qty]').value}. This is a preview; nothing has been added to the Shopify cart.`:'Please select a size first.';if(!size)this.querySelector('input[type="radio"]')?.focus();});
  on(this.querySelector('[data-favorite]'),'click',e=>{const b=e.currentTarget,chosen=b.getAttribute('aria-pressed')!=='true';b.setAttribute('aria-pressed',String(chosen));b.textContent=chosen?'♥':'♡';b.setAttribute('aria-label',chosen?'Remove from favourites':'Add to favourites');});
 }
 disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.querySelector('dialog')?.close();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotec-sliding-banner"] && !Shopify.designMode) return;
  try {
    
// The timeout and SVG ring share one elapsed clock; interruptions preserve remaining time.
if (!window.SpotecSlideClock) window.SpotecSlideClock = class {
  constructor(host, advance) { this.host=host; this.advance=advance; this.started=null; this.duration=0; this.remaining=0; }
  reset(duration) {
    this.stop(); this.animation?.cancel(); this.animation=null;
    this.duration=duration; this.remaining=duration;
    this.ring=this.host.querySelector('[data-slide-progress]');
    if(this.ring) this.ring.style.strokeDashoffset='100';
  }
  stop() {
    clearTimeout(this.timer);
    if(this.started!==null) this.remaining=Math.max(0,this.remaining-(performance.now()-this.started));
    this.started=null;
    if(this.animation){this.animation.pause();this.animation.currentTime=this.duration-this.remaining;}
  }
  sync(duration, run) {
    if(this.duration!==duration) this.reset(duration);
    if(!run){this.stop();return;}
    if(this.started!==null)return;
    if(!this.animation && this.ring?.animate) {
      this.animation=this.ring.animate([{strokeDashoffset:'100'},{strokeDashoffset:'0'}],{duration:this.duration,fill:'forwards',easing:'linear'});
    }
    if(this.animation){this.animation.currentTime=this.duration-this.remaining;this.animation.play();}
    this.started=performance.now();
    this.timer=setTimeout(()=>{
      this.started=null;this.remaining=0;
      this.animation?.finish();
      if(this.ring)this.ring.style.strokeDashoffset='0';
      this.advance();
    },this.remaining);
  }
  destroy(){this.stop();this.animation?.cancel();this.animation=null;}
};

/* Native custom element: each section owns its listeners, media and timer. */
if (!customElements.get('spotec-feature-banner')) {
  customElements.define('spotec-feature-banner', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (!this.slides.length) return;
      this.abort = new AbortController();
      const on = (target, event, handler) => target.addEventListener(event, handler, { signal: this.abort.signal });
      this.index = 0;
      this.hovered = false;
      this.focused = false;
      this.editorSelected = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.paused = this.motion.matches;
      this.dots = [...this.querySelectorAll('[data-go]')];
      this.pauseButton = this.querySelector('[data-pause]');
      this.querySelector('[data-controls]').hidden = this.slides.length < 2;
      on(this, 'click', (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-go')) this.show(Number(button.dataset.go), true);
        if (button.hasAttribute('data-step')) this.show(this.index + Number(button.dataset.step), true);
        if (button.hasAttribute('data-pause')) { this.paused = !this.paused; if(!this.paused)this.focused=false; this.update(); }
      });
      on(this, 'keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
      });
      on(this, 'pointerenter', (event) => { if (event.pointerType === 'mouse') { this.hovered = this.dataset.pauseOnHover==='true'; this.schedule(); } });
      on(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      on(this, 'focusin', event => { this.focused = event.target.matches?.(':focus-visible')??true; this.schedule(); });
      on(this, 'focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.schedule(); });
      on(this, 'touchstart', (event) => { this.touch = { x: event.touches[0].clientX, y: event.touches[0].clientY }; });
      on(this, 'touchend', (event) => {
        if (!this.touch) return;
        const dx = event.changedTouches[0].clientX - this.touch.x;
        const dy = event.changedTouches[0].clientY - this.touch.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1), true);
        this.touch = null;
      });
      on(document, 'spotec:popup-toggle', () => this.update());
      on(document, 'visibilitychange', () => this.update());
      on(this.motion, 'change', () => { if (this.motion.matches) this.paused = true; this.update(); });
      on(this.mobile, 'change', () => this.update());
      on(document, 'shopify:block:select', (event) => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.editorSelected = true; this.show(index); }
      });
      on(document, 'shopify:block:deselect', () => { this.editorSelected = false; this.update(); });
      this.clock=new window.SpotecSlideClock(this,()=>this.show(this.index+1));
      this.show(0);
    }

    disconnectedCallback() {
      this.clock?.destroy();
      this.abort?.abort();
      this.querySelectorAll('video').forEach(video => video.pause());
    }

    show(index, announce = false) {
      this.clock?.reset(Math.max(3000,(Number(this.dataset.interval)||5)*1000));
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== this.index;
        slide.inert = i !== this.index;
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      this.style.setProperty('--control-color', this.slides[this.index].dataset.controlsColor);
      if (announce) this.querySelector('[data-status]').textContent = `Banner ${this.index + 1} of ${this.slides.length}`;
      this.update();
    }

    update() {
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.pauseButton.setAttribute('aria-label', this.paused ? 'Play banners and videos' : 'Pause banners and videos');
      this.slides.forEach((slide, i) => {
        const host = slide.querySelector('[data-video-host]');
        if (!host) return;
        const play = i === this.index && !this.motion.matches && !this.paused && !document.hidden && !this.editorSelected && !document.querySelector('spotec-welcome-popup dialog[open]');
        if (play && !host.firstElementChild) host.append(slide.querySelector('template').content.cloneNode(true));
        const video = host.querySelector('video');
        host.classList.remove('is-playing');
        if (!video) return;
        if (play) {
          video.muted = true;
          video.play().then(() => { if (!slide.hidden && !video.paused) host.classList.add('is-playing'); }).catch(() => {});
        } else video.pause();
      });
      this.schedule();
    }

    schedule() {
      const blocked=document.querySelector('spotec-welcome-popup dialog[open]') || this.motion.matches || this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.paused || this.hovered || this.focused || this.editorSelected || document.hidden;
      this.clock?.sync(Math.max(3000,(Number(this.dataset.interval)||5)*1000),!blocked);
    }

  });
}


  } catch(e) { console.error(e); }
})();
})();
